import React, { ReactElement } from 'react';
import { connect } from 'react-redux';

import { actions as filterActions } from '../../../state/filterActions';
import { fetchResults } from '../../../state/resultActions';

import { ApiQueryParams, CheckboxTree, NestedFacet, PaleState } from '../../../interfaces';
import { CollapsibleContinent } from './CollapsibleContinent';

interface Props {
    destinations: NestedFacet[];
    checked: CheckboxTree;
    checkboxClick: (path: string[]) => void;
    triggerFetch: (queryParams?: ApiQueryParams) => void;
}

export const displayName = (facet: NestedFacet): string => facet.value.split(';').pop() || '';

export const destinationSort = (facet1: NestedFacet, facet2: NestedFacet): number => (facet2.count || 0) - (facet1.count || 0);

export const DestinationFilter: React.FC<Props> = ({ destinations, checked, checkboxClick, triggerFetch }): ReactElement<Props> => (
    <div data-testid="destinationFilter">
        {[...destinations].sort(destinationSort).map((continent) => (
            <CollapsibleContinent
                key={continent.value}
                continent={continent}
                checked={checked}
                checkboxClick={checkboxClick}
                triggerFetch={triggerFetch}
                displayValue={displayName}
                sortChildren={destinationSort}
            />
        ))}
    </div>
);

const mapStateToProps = (state: PaleState): Pick<Props, 'destinations' | 'checked'> => ({
    destinations: state.results.facets.location,
    checked: state.filters.destinations.tree,
});

const mapDispatchToProps = {
    checkboxClick: filterActions.filterCheckboxDestination,
    triggerFetch: fetchResults,
};

export default connect(mapStateToProps, mapDispatchToProps)(DestinationFilter);
